<template>
  <LineChartGenerator 
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
  />
</template>
<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
)

export default {
  name: 'LineChart',
  components: {
    LineChartGenerator
  },
  props: {
    chartId: {
      type: String,
      default: 'line-chart'
    },
    chartData: {
      type: Object,
      default: () => {}
    },
    chartOptions: {
      type: Object,
      default: () => {}
    }
  },
  computed: {

  },
  mounted () {

  },
  data() {
    return {
      
    }
  }
}
</script>

<style lang="stylus">
.chart-container
  canvas
    width: 100% !important;
</style>